const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const handleProviderProvider = require('mn-utils/changeProviderProviderSimple');
const {
  COUNTRIES,
} = require('../../../../../../constants/countries');
const numberHandle = require('../../../../../../utils/numberHandle');
const withState = require('../../../../../../utils/withState');
const Select = require('../../../../../dumb/Select/F');
const TextField = require('../../../../../dumb/TextField/I');
const KeyboardDatePickerA = require('../../../../../dumb/KeyboardDatePicker/A');
const WrapperWithLoading = require('../../../../../dumb/WrapperWithLoading/B');

const InputUploadDocs = require('../UploadDocs');


const DOC_TYPES = [
  ['Passport', 'passport'],
  ['National ID', 'national_id'],
];


module.exports = withState((setState, self) => {
  const set = self.props.setState;
  const changeProvider = changeProviderProvider(set);
  const handleProvider = handleProviderProvider(set);

  const handleChangeFullname = changeProvider('fullname');
  const handleChangeBirthday = handleProvider('birthday');
  const handleChangeCountryOfResidence = handleProvider('countryOfResidence');
  const handleChangeCountryOfBirth = handleProvider('countryOfBirth');
  const handleChangePassportOrNationId = handleProvider('passportOrNationId');
  const handleChangePercentShares = changeProvider('percentShares', 0, numberHandle);
  const handleChangeDocDirectorsPassportOrNationalId
    = handleProvider('docDirectorsPassportOrNationalId');
  const handleChangeLoadingDocDirectorsPassportOrNationalId
    = handleProvider('loadingDocDirectorsPassportOrNationalId');
  const handleChangeDocDirectorsProofOfAddress
    = handleProvider('docDirectorsProofOfAddress');
  const handleChangeLoadingDocDirectorsProofOfAddress
    = handleProvider('loadingDocDirectorsProofOfAddress');

  return (_state, props) => {
    const {
      data,
      handleOpenConfirm,
      handleOpenConfirmRemove,
      clicked,
    } = props;
    const {
      invalid,
      state,
    } = data;


    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <div className="f12 fw3 lh18 lts0em tl">
          Please add all UBOs (Ultimate Beneficial Owners),
          who hold at least 20% of the company shares
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt20">
          <div>
            <TextField
              label="Full name *"
              value={state.fullname || ''}
              onChange={handleChangeFullname}
              error={clicked && invalid.fullname}
            />
          </div>
          <div className="mt20@m">
            <KeyboardDatePickerA
              error={clicked && (
                invalid.birthday
                || invalid.birthdayInFuture
              )}
              label="Date of birth *"
              disableFuture
              value={state.birthday || null}
              onChange={handleChangeBirthday}
              helperText={
                invalid.birthdayInFuture
                  ? 'Value can\'t be from future'
                  : ''
              }
            />
          </div>
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt20">
          <div>
            <Select
              placeholder="Country of residence *"
              error={clicked && invalid.countryOfResidence}
              propName="0"
              propValue="1"
              displayEmpty
              items={COUNTRIES}
              value={state.countryOfResidence || ''}
              onChange={handleChangeCountryOfResidence}
            />
          </div>
          <div className="mt20@m">
            <Select
              placeholder="Country of birth *"
              error={clicked && invalid.countryOfBirth}
              propName="0"
              propValue="1"
              displayEmpty
              items={COUNTRIES}
              value={state.countryOfBirth || ''}
              onChange={handleChangeCountryOfBirth}
            />
          </div>
        </div>
        <div className="cfx mh-10 (lt|ph10|w1/2|w@m)>1 mt20">
          <div>
            <Select
              placeholder="Passport / national ID number *"
              error={clicked && invalid.passportOrNationId}
              propName="0"
              propValue="1"
              displayEmpty
              items={DOC_TYPES}
              value={state.passportOrNationId || ''}
              onChange={handleChangePassportOrNationId}
            />
          </div>
          <div className="mt20@m">
            <TextField
              label="% of shares *"
              value={state.percentShares || ''}
              onChange={handleChangePercentShares}
              error={clicked && invalid.percentShares}
            />
          </div>
        </div>
        <div
          className="mt20 f12 fw3 lh18 lts0em tl"
        >Provide us with supporting documents</div>
        <div className="mt10 f12 fw3 lh18 lts0em c828282">
          We need these documents to open your account with us.<br/>
          Accepted types - PDF, scanned copy, clear photo JPEG, JPG, PNG and not
          more than 25 MB for each document.
        </div>
        <div className="cfx mh-10 (lt|ph10|mt20|w1/2|w@m)>1">
          <InputUploadDocs
            labelHeader="Passport or national ID *"
            labelContent="A passport or national ID document to verify your identity."
            value={state.docDirectorsPassportOrNationalId}
            type="owner_document_identity"
            onChange={handleChangeDocDirectorsPassportOrNationalId}
            onLoading={handleChangeLoadingDocDirectorsPassportOrNationalId}
            error={clicked && invalid.docDirectorsPassportOrNationalId}
            openConfirm={handleOpenConfirm}
            openConfirmRemove={handleOpenConfirmRemove}
          />
          <InputUploadDocs
            labelHeader="Proof of address *"
            labelContent="A document, bank statement or utility bills
            not older than 3 months, containing the address."
            value={state.docDirectorsProofOfAddress}
            type="owner_document_address"
            onChange={handleChangeDocDirectorsProofOfAddress}
            onLoading={handleChangeLoadingDocDirectorsProofOfAddress}
            error={clicked && invalid.docDirectorsProofOfAddress}
            openConfirm={handleOpenConfirm}
            openConfirmRemove={handleOpenConfirmRemove}
          />
        </div>
      </WrapperWithLoading>
    );
  };
}, {});
